import { render, staticRenderFns } from "./KtButton.vue?vue&type=template&id=d685e3ec&scoped=true"
import script from "./KtButton.vue?vue&type=script&lang=js"
export * from "./KtButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d685e3ec",
  null
  
)

export default component.exports